import { DateTime } from 'luxon'

import { CertificateDataWithLink } from '../certificate.types'

export const FacebookShareLink = (link: string) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${
    link ? encodeURIComponent(link) : ''
  }`
}

export const TwitterShareLink = (link: string, text: string, tags: string) => {
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    `${text}\nLink: ${link}\n${tags}`
  )}`
}

export const WhatsappShareLink = (link: string, text: string) => {
  return `https://api.whatsapp.com/send?text=${encodeURIComponent(
    `${text}\nLink: ${link}`
  )}`
}

export const LinkedinShareLink = (link: string) => {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    link
  )}`
}

export const LinkedinAddCertificateToProfile = (
  certificateData: CertificateDataWithLink
) => {
  const formatedDate = DateTime.fromISO(certificateData.created_at).toFormat(
    'yyyy-MM-dd'
  )
  return `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${encodeURIComponent(
    certificateData.title
  )}&certUrl=${certificateData.link}&certId=${certificateData.cuid}${
    (formatedDate &&
      formatedDate.split('-').length === 3 &&
      `&organizationId=43234652&issueYear=${
        formatedDate.split('-')[0]
      }&issueMonth=${formatedDate.split('-')[1]}`) ||
    ''
  }`
}
